import Button from 'domains/core/components/Button';
import { PlayMessageNode, VoiceTemplateState } from './VoiceTemplateReducer';
import { useEffect, useState } from 'react';

type PropType = {
    handleOnSave: () => void;
    isLoading: boolean;
    isError: boolean;
    voiceTemplateState: VoiceTemplateState;
};

const SaveExitButton: React.FunctionComponent<PropType> = ({
    handleOnSave,
    isLoading,
    isError,
    voiceTemplateState,
}) => {
    const [valid, setValid] = useState(false);

    useEffect(() => {
        if ((voiceTemplateState.voiceTemplateFlowState?.root as PlayMessageNode).message.length > 3) {
            setValid(true);
        } else {
            setValid(false);
        }
        if (isLoading || isError) {
            setValid(false);
        }
    }, [voiceTemplateState, isLoading, isError]);

    return (
        <Button
            variant="outlined"
            color="primary"
            style={{ marginTop: '20px', width: '100%' }}
            onClick={handleOnSave}
            disabled={!valid}
        >
            Save & Exit
        </Button>
    );
};

export default SaveExitButton;
